import { render } from "./healthCode.vue?vue&type=template&id=83c7eeba&scoped=true"
import script from "./healthCode.vue?vue&type=script&lang=js"
export * from "./healthCode.vue?vue&type=script&lang=js"

import "./healthCode.vue?vue&type=style&index=0&id=83c7eeba&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83c7eeba"]])

export default __exports__